import React, {useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Services() {
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);
  return (
    <>
    <section id="Services" className="services">
        <div className="container" data-aos="fade-up">
            <div className="section-title">
              <h2>Services</h2>
              <h3>Our <span>Services</span></h3>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                <div className="icon-box">
                  <div className="icon"><i className="bi bi-code-square"></i></div>
                  <h4>Software Development</h4>
                  <p>We Provide ERP Solution, Custom Software Solution for Bussiness need. Pathology Software, Billing/Iventory Software, School/College Software, Cold Store Software</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="200">
                <div className="icon-box">
                  <div className="icon"><i className="bi bi-browser-edge"></i></div>
                  <h4>Web Development</h4>
                  <p>We Provide Professional & Customized Web Portal Services i.e. School, Hospital, MLM, News Portal, e-commerce, Online Booking </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0" data-aos="zoom-in" data-aos-delay="300">
                <div className="icon-box">
                  <div className="icon"><i className="bi bi-ui-checks-grid"></i></div>
                  <h4>Web Design</h4>
                  <p>We Provide Professional and Responsive Web Site Design</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="100">
                <div className="icon-box">
                  <div className="icon"><i className="bi bi-apple"></i></div>
                  <h4>App Development</h4>
                  <p>We Provide Hybrid and Native app Development</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="200">
                <div className="icon-box">
                  <div className="icon"><i className="bi bi-twitch"></i></div>
                  <h4>Digital Marketing</h4>
                  <p>We Provide Digital Plateform for Business Promotional Services that customer can achive maximum goals.  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="300">
                <div className="icon-box">
                  <div className="icon"><i className="bi bi-chat-quote-fill"></i></div>
                  <h4>Bulk SMS</h4>
                  <p>We Provide Bulk SMS Services in DLT Plateform for Promotional Actvities.</p>
                </div>
              </div>
            </div>
        </div>
    </section>
    </>
  )
}
